import React, { useCallback, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router";
import Box from "@mui/material/Box";

import AssetDetailsModal from "../../../../components/TablePro/components/assets/AssetDetailsModal";
import KitDetailsModal from "../../../../components/TablePro/components/assets/KitDetailsModal";
import { KitAssetsProvider } from "../../../../contexts/kit-assets";
import { useEditAsset } from "../../../../components/TablePro/Table/EditAssetProvider";

export default function EditAssetModal({ entity, value, onClose }) {
  const { clientId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const editAsset = useEditAsset();
  const isKitting = location.pathname.includes("kitting");
  const shouldSyncUrl = isKitting || location.pathname.includes("/assets");
  const assetIdParam = isKitting ? "kitDetailsId" : "assetId";

  useEffect(() => {
    if (!isKitting && editAsset?.setAsset) {
      editAsset.setAsset(entity);
      onClose();
    }
  }, [editAsset, entity, isKitting, onClose]);

  const updateAssetIdParam = useCallback(
    nextAssetId => {
      if (!shouldSyncUrl) return;

      const params = new URLSearchParams(location.search);

      if (nextAssetId) {
        params.set(assetIdParam, nextAssetId);
      } else {
        params.delete(assetIdParam);
      }

      if (params.toString() === location.search.replace(/^\?/, "")) return;

      navigate(
        {
          pathname: location.pathname,
          search: params.toString(),
          hash: location.hash,
        },
        { replace: true }
      );
    },
    [assetIdParam, location.hash, location.pathname, location.search, navigate, shouldSyncUrl]
  );

  useEffect(() => {
    if (!isKitting && editAsset?.setAsset) return;
    updateAssetIdParam(isKitting ? entity.itemId : entity.id);
  }, [editAsset, entity.id, entity.itemId, isKitting, updateAssetIdParam]);

  const handleClose = () => {
    updateAssetIdParam(null);
    onClose();
  };

  return (
    <>
      <Box underline="none" sx={{ cursor: "pointer" }} color="primary.main" className="unfocus">
        {value || ""}
      </Box>
      {!isKitting && editAsset?.setAsset ? null : (
        <>
          {isKitting ? (
            <KitAssetsProvider id={entity.id}>
              <KitDetailsModal entity={entity} onClose={handleClose} />
            </KitAssetsProvider>
          ) : (
            <AssetDetailsModal clientId={clientId} entity={entity} onClose={handleClose} />
          )}
        </>
      )}
    </>
  );
}
